<template>
	<div 
		class="accordion-fieldset"
		:class="[
			{ 'accordion-fieldset--toned': !hasMandatoryFields && !show },
		]"
	>
		<button
			class="accordion-fieldset__head"
			@click="sendToggleStatus"
		>
			<div class="accordion-fieldset__head__left">
				<!-- Icon -->
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-if="icon == 'pen'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M20.45 7.13L17.63 4.3a1 1 0 00-1.42 0L5 15.5a.88.88 0 00-.27.51L4 19.54a1 1 0 00.27.9 1 1 0 00.71.3h.2L8.75 20a1.1 1.1 0 00.51-.27L20.45 8.55a1 1 0 00.3-.71 1 1 0 00-.3-.71zM6.29 18.43L6.58 17a2.37 2.37 0 01.65.49 2.42 2.42 0 01.49.65zm2.29-.84a3.68 3.68 0 00-.61-.8 3.94 3.94 0 00-.8-.61L15 8.37l1.41 1.41zM17.13 9l-1.44-1.34 1.23-1.24 1.41 1.42z"/></svg>

				<!-- Heading -->
				<div class="accordion-fieldset__titles">
					<h4>{{ title }}</h4>
				</div>
			</div>

			<div class="accordion-fieldset__head__right">

				<!-- Validation indication -->
				<template v-if="hasMandatoryFields">

					<!-- Green -->
					<span 
						v-if="missingFields == 0" 
						class="validation-indication validation-indication--green"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon icon-check'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
					</span>

					<!-- Red -->
					<span v-else class="validation-indication">
						{{ missingFields }}
					</span>

				</template>

				<!-- Close icon -->
				<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg" v-if="show === true" v-bind:svg-inline="''" v-bind:class="'icon icon-minus'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M0 2V0h14v2z" fill-rule="evenodd"/></svg>

				<!-- Open icon -->
				<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:class="'icon icon-plus'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill-rule="evenodd"/></svg>
			</div>
			
		</button>

		<transition-accordion>
			<div class="accordion-fieldset__body" v-if="show">
				<div class="accordion-fieldset__body-inner">
					<slot></slot>
				</div>
			</div>
		</transition-accordion>
	</div>
</template>

<script>
import TransitionAccordion from '../atoms/TransitionAccordion'

export default {
	name: 'Accordion',
	components: {
		TransitionAccordion
	},
	props: {
		title: String,
		icon: String,
		//defaultState: String,
		show: {
			type: Boolean,
			default: false
		},
		// lightTheme: {
		// 	type: Boolean,
		// 	default: false
		// },
		// disabled: {
		// 	type: Boolean,
		// 	default: false
		// },
		missingFields: {
			type: Number,
			default: null
		},
		hasMandatoryFields: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {}
	},
	methods: {
		sendToggleStatus() {
			this.$emit('toggle')
		}
	}
}
</script>

<style scoped lang="scss">
// Reset button styling
button {
	display: block;
	width: 100%;
	padding: 0;
	border: none;
	outline: none;
	font: inherit;
	color: inherit;
	background: none;
	text-align: left;

	&:hover &:focus {
		border: none;
	}
}

.accordion-fieldset {
	width: 100%;
	margin-bottom: 10px;

	// .disabled {
	// 	background-color: $colorGrey1;
	// 	pointer-events: none;
	// 	cursor: auto;
	// }

	&__head {
		display: flex;
		justify-content: space-between;
		background-color: $colorWhite;
		cursor: pointer;
		padding: 22px 20px;

		// @include for-tablet-portrait-up {
		// 	background-color: $colorGrey0;
		// 	padding: $spacing4;
		// }

		&__left {
			display: flex;
			align-items: center;
			gap: 6px;

			@include for-tablet-portrait-up {
				gap: 20px;
			}

			svg {
				width: 25px;
				height: 25px;
				fill: $colorPrimary9;
				// margin-bottom: 2px;
			}

			> img {
				align-self: flex-end;
				margin-bottom: $spacing2;
			}

			// .accordion-titles h4 {
			// 	font-size: 18px;
			// 	line-height: 20px;
			// 	margin-right: 7px;

			// 	@include for-tablet-portrait-up {
			// 		font-size: 22px;
			// 		line-height: 26px;
			// 	}
			// }
		}

		&__right {
			display: flex;
			align-items: center;
			align-self: flex-end;
			position: relative;
			margin-bottom: 0;

			> svg {
				fill: $colorSecondary9;
				width: 20px;
				height: 20px;

				&.icon-plus {
					fill: #04BEFB;
				}
			}

			.validation-indication {
				display: inline-block;
				width: 24px;
				height: 24px;
				background: rgba(#E15B5B, 0.5);
				border-radius: 50%;
				padding: 0;
				font-size: 12px;
				line-height: 24px;
				text-align: center;
				color: white;
				margin-right: 20px;
				box-sizing: border-box;

				svg {
					width: 10px;
					height: 10px;
					fill: white;
					display: inline-block;
					// vertical-align: middle;
					margin-top: 6px;
				}

				&--green {
					background: #7FC3BB;
				}
			}
		}
		
	}

	&__body {
		background-color: $colorGrey0;
		background-color: $colorWhite;

		&-inner {
			padding: 0 20px 20px 20px;
		}

		&:first-child {
			margin-top: 0;
		}
	}

	&__titles {
		position: relative;

		p {
			font-size: 13px;
			line-break: 21px;
		}

		h4 {
			font-size: 18px;
			line-height: 20px;
			color: $colorGrey9;
			margin-right: 7px;
		}

		.accordion-titles h4 {
				@include for-tablet-portrait-up {
					font-size: 22px;
					line-height: 26px;
				}
			}

		> * {
			margin-top: $spacing1;

			&:first-child {
				margin-top: 0;
			}
		}

		p {
			margin-bottom: 0;
		}
	}

	&--toned {
		.accordion-fieldset__titles h4 {
			color: #7F8BA1;
		}
		.accordion-fieldset__head__left svg {
			fill: #7F8BA1;
		}
	}
}
</style>
